import React, { useState } from 'react';
import FaceLiveness from './FaceLiveness';
import axios from 'axios';
import API_BASE_URL from '../../config';
import { useSelector } from 'react-redux';
import './FaceEnrollModal.css';

/**
 * Modal para registrar el rostro del coordinador.
 * Se muestra desde el dropdown de la Navbar.
 *
 * Props:
 *   onClose() — cerrar el modal
 */
function FaceEnrollModal({ onClose }) {
  const token = useSelector((state) => state.auth.token);
  const [phase, setPhase] = useState('instructions'); // instructions | scanning | success | error
  const [errorMsg, setErrorMsg] = useState(null);

  const handleLivenessConfirmed = async (descriptor) => {
    setPhase('saving');
    setErrorMsg(null);
    try {
      await axios.post(
        `${API_BASE_URL}auth/enroll-face`,
        { descriptor },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPhase('success');
    } catch (err) {
      const msg = err.response?.data?.error || 'Error al guardar el rostro. Intenta de nuevo.';
      setErrorMsg(msg);
      setPhase('error');
    }
  };

  return (
    <div className="fenroll-backdrop" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="fenroll-modal">
        {/* Header */}
        <div className="fenroll-header">
          <div className="fenroll-icon-wrap">
            <i className="fa fa-camera fenroll-icon" />
          </div>
          <h2 className="fenroll-title">Registrar rostro</h2>
          <p className="fenroll-subtitle">
            Esto te permitirá iniciar sesión con tu cara y pasar las verificaciones de turno.
          </p>
          <button className="fenroll-close" onClick={onClose} aria-label="Cerrar">
            <i className="fa fa-times" />
          </button>
        </div>

        {/* Contenido por fase */}
        {phase === 'instructions' && (
          <div className="fenroll-body">
            <ul className="fenroll-tips">
              <li><i className="fa fa-check-circle" /> Busca un lugar con buena iluminación</li>
              <li><i className="fa fa-check-circle" /> Retira lentes de sol o cubrebocas</li>
              <li><i className="fa fa-check-circle" /> Mira directo a la cámara</li>
              <li><i className="fa fa-check-circle" /> Cuando aparezca "¡Ahora parpadea!", parpadea normalmente</li>
            </ul>
            <button className="fenroll-btn-primary" onClick={() => setPhase('scanning')}>
              <i className="fa fa-camera" /> Comenzar escaneo
            </button>
          </div>
        )}

        {phase === 'scanning' && (
          <div className="fenroll-body">
            <FaceLiveness
              title="Escanea tu rostro"
              onConfirmed={handleLivenessConfirmed}
              onError={(e) => { setErrorMsg(e); setPhase('error'); }}
            />
            <button
              className="fenroll-btn-secondary"
              style={{ marginTop: 12 }}
              onClick={() => setPhase('instructions')}
            >
              ← Volver
            </button>
          </div>
        )}

        {phase === 'saving' && (
          <div className="fenroll-body fenroll-center">
            <div className="fenroll-spinner" />
            <p className="fenroll-saving-text">Guardando tu rostro de forma segura...</p>
          </div>
        )}

        {phase === 'success' && (
          <div className="fenroll-body fenroll-center">
            <div className="fenroll-success-icon">✅</div>
            <h3 className="fenroll-success-title">¡Rostro registrado!</h3>
            <p className="fenroll-success-sub">
              A partir de ahora puedes iniciar sesión usando la pestaña "Rostro" y pasarás
              las verificaciones automáticas del turno.
            </p>
            <button className="fenroll-btn-primary" onClick={onClose}>
              Entendido
            </button>
          </div>
        )}

        {phase === 'error' && (
          <div className="fenroll-body fenroll-center">
            <div className="fenroll-error-icon">❌</div>
            <p className="fenroll-error-text">{errorMsg}</p>
            <button className="fenroll-btn-primary" onClick={() => setPhase('scanning')}>
              Intentar de nuevo
            </button>
            <button className="fenroll-btn-secondary" onClick={onClose}>
              Cancelar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default FaceEnrollModal;
